import React from "react";
import { Row } from "antd";
function KoRow(props) {
  const { children, gutter=20, className} = props;
  return (<Row gutter={gutter} className={className}>
    {children}
  </Row>);
}

export default KoRow;